import { getImageQuality } from '../utils'

const configAggregator = (node) => {
    return {
        brand: node.getAttribute('data-w-brand'),
        heading: node.getAttribute('data-w-heading'),
        subHeading: node.getAttribute('data-w-sub-heading'),
        contentPosition: node.getAttribute('data-w-content-position'),
        textColor: node.getAttribute('data-w-text-color'),
        image: node.getAttribute('data-w-image'),
        tabletImage: node.getAttribute('data-w-tablet-image'),
        mobileImage: node.getAttribute('data-w-mobile-image'),
        imageQuality: getImageQuality([]),
        showButton: node.getAttribute('data-w-show-button'),
        buttonText: node.getAttribute('data-w-button-text'),
        buttonLink: node.getAttribute('data-w-button-link'),
        buttonColor: node.getAttribute('data-w-button-color'),
        buttonBgColor: node.getAttribute('data-w-button-background-color')
    }
}

export default configAggregator
